import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import { grey } from '@material-ui/core/colors';


import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box, Typography} from '@material-ui/core'
import {Button, TextField} from '@material-ui/core';
import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';

import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getObjectByID } from '../../../api/helpers';

class SelectDispatcherDialog_ extends React.Component{

    constructor(props){
        super(props)

        //console.log('this.props.networks')
        //console.log(this.props.networks)

        this.state = {
            changed: false,
            panelsExpanded: {},
            dispatcherFilter: '',
            errors: {
                dispatcherName: false
            },
            selected : {
                networkID: null,
                dispatcherID: null,
                dispatcher: null
            }
        }

        this.handleSelect = this.handleSelect.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleFilterInput = this.handleFilterInput.bind(this)
    }

    handleSelect(){
        if(this.validate()){
            this.props.onAction({type: 'SELECT_DISPATCHER_DIALOG_SELECT', ...this.state.selected })
        }
    }

    handleClose(){
        this.props.onAction({type: 'SELECT_DISPATCHER_DIALOG_CLOSE'})
    }

    handleFilterInput(event){
        const val =  event.target.value
        console.log('handleFilterInput')
        console.log(event.target.name +' = ' +val)

        this.setState({[event.target.name]: val})
    }

    validate(){
        let error = false

        return !error;
    }


    togglePanel(event, expanded, panel){
        this.setState(state => {
            state.panelsExpanded[panel] = expanded
            return state
        })
    }

    isSelected(netID, dispatcherID){
        //console.log('isSelected')
        //console.log(this.state.selected)
        //console.log(netID + ' ' + dispatcherID)


        let selected = this.state.selected
        //console.log('selected')
        //console.log(selected)

        let isSelected = netID === selected.networkID && dispatcherID === selected.dispatcherID

        //console.log('isSelected='+ (isSelected?'true':'false'))

         return isSelected
    }


    getRowStyle(netID, groupID, slot){
        let style = {
            background: this.isSelected(netID, groupID, slot) ? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    select(netID, dispatcherID){
        let network = getObjectByID(netID, this.props.networks)
        let dispatcher = getObjectByID(dispatcherID, network.users)

        //console.log('select')
        //console.log(netID)
        //console.log(dispatcherID)

        let selected = {
            networkID: netID,
            dispatcherID: dispatcher.ID,
            dispatcher: dispatcher.Name
        }
        //console.log('selected')
        //console.log(selected)

        this.setState({selected: selected})
    }

    selectClose(netID, dispatcherID){
        let network = getObjectByID(netID, this.props.networks)
        let dispatcher = getObjectByID(dispatcherID, network.users)

        let selected = {
            networkID: netID,
            dispatcherID: dispatcher.ID,
            dispatcher: dispatcher.Name
        }

        if(this.validate()){
            this.props.onAction({type: 'SELECT_DISPATCHER_DIALOG_SELECT', ...selected })
        }
    }


    render(){
        const {t} = this.props


        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            icon:{
                width: 30
            },
            addIcon: {
                color: 'white'
            }
        };

        const title = t('SelectItem')

        //const margin = {margin:'16px 0 8px 0'}

        //console.log('render SelectExternalNetworkGroupDialog')
        //console.log(this.props)

        let networks = []
        if(this.props.networkID){
            //console.log('single network ')
            //console.log(this.props.networks)
            networks = this.props.networks.filter(net => net.ID==this.props.networkID)
            console.log(networks)
        }else{
            networks = this.props.networks
        }


        let filter = this.state.dispatcherFilter.toLowerCase()
        
        if(filter || true){
            console.log('networks before filter')
            console.log(networks)
            networks = networks.map(
                net => ({
                            ID: net.ID, 
                            Name: net.Name,
                            users: net.users.filter(
                                item => ((item.Type==1) && (filter ? item.Name.toLowerCase().indexOf(filter) >= 0 : true))
                            )
                        })
            )
            console.log('networks after filter')
            console.log(networks)
        }

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>        

            <Box textAlign="center">
                <TextField
                    name="dispatcherFilter"
                    id="dispatcherFilter"
                    onChange={this.handleFilterInput}
                    label={t("Filter")}
                    value={this.state.dispatcherFilter}
                    style={{width:'100%'}}
                    error={false}
                    autoComplete="new-password"
                />
            </Box>

            {networks.map(net=>(

            <ExpansionPanel key={net.ID}
                expanded={this.state.panelsExpanded[net.ID]==undefined?true:this.state.panelsExpanded[net.ID]} 
                onChange={(event, expanded) => this.togglePanel(event, expanded, net.ID)}>
                <ExpansionPanelSummary style={{background: grey[300]}} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{net.Name}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{display: 'block', margin:0, padding:0}}>
                    
                    <Table size="small">

                    <TableHead>
                            <TableRow>
                                <TableCell style={styles.head}>{t('Name')}</TableCell>
                            </TableRow>
                        </TableHead>
                    
                    <TableBody>
                    {net.users.map(dispatcher=>
                    <TableRow key={dispatcher.ID}  
                        onClick={event=>this.select(net.ID, dispatcher.ID)}
                        onDoubleClick={event=>this.selectClose(net.ID, dispatcher.ID)}
                        style={this.getRowStyle(net.ID, dispatcher.ID)}>
                        <TableCell>
                            {dispatcher.Name}
                        </TableCell>
                    </TableRow>
                    )}
                    </TableBody>
                    </Table>

                </ExpansionPanelDetails>
            </ExpansionPanel>
            ))}

            

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSelect} variant="contained" color="primary">
            {t('Select')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const SelectDispatcherDialog = withTranslation()(SelectDispatcherDialog_);